import TableAssociateFiles from '../../../../components/table/files/TableAssociateFiles'

const AssociateFilesPage = () => {
  return <TableAssociateFiles />
}

export default AssociateFilesPage
